import { render } from "./EditSeminarKursusView.vue?vue&type=template&id=714376bd"
import script from "./EditSeminarKursusView.vue?vue&type=script&lang=js"
export * from "./EditSeminarKursusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__